import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BiWorld } from 'react-icons/bi';
import { FaRegUser } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';
import { TbLogout } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import MessageBox from '../../../components/MessageBox';
import { RxHamburgerMenu } from 'react-icons/rx';
import { toast } from 'react-toastify';
import { LogOut, capsFirstLetter } from '../../Pages/CommonMethods/CommonMethods';

const AdvertiserHeader = ({ toggleAction }) => {
  const [showProfile, setShowProfile] = React.useState(false);
  let userName, advertiserName;

  if (localStorage.getItem("username")) {
    userName = localStorage.getItem("username");
  } else {
    advertiserName = localStorage.getItem("name");
  }
  const capitalizedUsername = userName ? capsFirstLetter(userName) : capsFirstLetter(advertiserName);

  const toggleAdvertiseNavbar = () => { toggleAction() };

  const handleLogout = () => {
    LogOut('/login');
    toast.success("Logged out successfully");
  };

  const toggleProfile = () => {
    setShowProfile(!showProfile);
  }

  return (
    <nav className="theme-bg-color container-fluid py-2 py-sm-3 advertiserHeader">
      <ul className="d-flex align-items-center justify-content-between p-0 m-0 list-unstyled">
        <li>
          <button type="button" onClick={toggleAdvertiseNavbar} className="bg-transparent d-inline-flex p-2 toggleAdminButton">
            <RxHamburgerMenu className="adminIcon" />
          </button>
        </li>
        <li className="nav-item mb-2 position-relative">
          <div 
            id="account_capitalizedUsername" 
            className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative ${!showProfile ? 'collapsed' : ''}`}
            onClick={toggleProfile}
            style={{ cursor: 'pointer' }}
          >
            <div>
              <FaRegUser fill='currentColor' className="z-index-for-channel position-relative" />
              <MessageBox text={capitalizedUsername} classname="ms-2 theme-text-color text-break" />
            </div>
            <IoIosArrowDown style={{ transform: showProfile ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }} />
          </div>

          {showProfile && (
            <div 
              className="profileDropdownOverlay p-0 shadow-lg" 
              id="AccountDetails" 
              style={{ 
                display: 'block', 
                position: 'absolute', 
                zIndex: 100000, 
                right: '0px', 
                top: '50px',
                width: '200px'
              }}
            >
              <div className="theme-bg-color p-3 rounded-2 border">
                <Link className="headerSubLink d-block mt-2 " to="/account_detail" id="account_detail" aria-label={"My Profile"} onClick={() => setShowProfile(false)} >
                  <CgProfile /> My Profile
                </Link>
                <div className='theme-border-bottom-secondary mt-3'></div>
                <Link className="headerSubLink d-block mt-3" id="account_detailLogout" aria-label={"Logout"} onClick={handleLogout} >
                  <TbLogout /> Logout
                </Link>
              </div>
            </div>
          )}
        </li>
      </ul>
    </nav>
  )
}

export default AdvertiserHeader